
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/witchy-tabby",
      function () {
        return require("private-next-pages/witchy-tabby/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/witchy-tabby"])
      });
    }
  